import React, { useState } from 'react';
import PortalWrapper from '../PortalWrapper';
import StreamingIcon from '../../svg/StreamingIcon';
import { classIf } from '../../data/utils';
import WidgetContextProvider from '../../WidgetContextProvider';
import StreamingProvider from './StreamingProvider';
import LiveTracker from './LiveTracker';

export default function LiveTrackerToggle(props) {
    const data = props.data;
    const [toggled, setToggled] = useState(false);

    return (
        <>
            <StreamingIcon className={"c_18_1_3_1" + classIf(toggled, 'active')} onClick={() => setToggled(!toggled)} />
            {toggled &&
                <PortalWrapper container="xs-live-tracker">
                    <WidgetContextProvider>
                        <StreamingProvider>
                            <LiveTracker data={data} wrapper={true} />
                        </StreamingProvider>
                    </WidgetContextProvider>
                </PortalWrapper>
            }
        </>
    );
}
